import { Grid, Typography } from "@mui/material";
import React from "react";

const EmptyDoctor = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ textAlign: "center", padding: "80px 0" }}
    >
      <Grid item>
        <Typography
          variant="h5"
          sx={{
            color: "#212121",
            fontSize: "21px",
            fontWeight: 500,
          }}
        >
          No doctors found
        </Typography>
        <Typography sx={{ color: "#444444", maxWidth: "350px", width: "100%" }}>
          There are no doctors with the above criteria. Please try searching
          with different filters.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default EmptyDoctor;
